import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import lowerCase from 'lodash/lowerCase';

import resolveFamilyMemberOption from '../../../utils/converters/resolveFamilyMemberOption';
import { isCaregiver, isGuardianProxyPatent } from '../utils/checkUserRole';
import { CANCEL_INVITE } from '../../../constants/strings';
import CancelPopup from '../../CircleList/CancelPopup';
import CancelForm from '../../CircleList/CancelForm';
import { enhance } from './enhance';

function CancelPendingInvitationsPopup({
  user,
  onClose,
  rejected,
  succeed,
  clearRequests,
  targetUserId,
  formatMessage,
  cancelGuardianInvite,
  cancelCaregiverInvite,
  cancelFamilyMemberInvite,
}) {
  useEffect(() => {
    if (succeed) {
      handleClose();
    }
  }, [succeed]);

  const { role, login, invitationId, careRole } = user;
  const cancelPopupText = formatMessage(CANCEL_INVITE.text, {
    role: lowerCase(resolveFamilyMemberOption({ role }, formatMessage)),
    login,
  });

  const cancelAction = () => {
    if (isGuardianProxyPatent(careRole)) return cancelGuardianInvite;
    if (isCaregiver(careRole)) return cancelCaregiverInvite;
    return cancelFamilyMemberInvite;
  };

  const handleClose = () => {
    onClose();
    clearRequests();
  };

  return (
    <CancelPopup
      isOpened
      onClose={handleClose}
      title={formatMessage(CANCEL_INVITE.title)}
    >
      <CancelForm
        userId={targetUserId}
        onClose={handleClose}
        onSubmit={cancelAction()}
        invitationId={invitationId}
        text={cancelPopupText}
        rejected={rejected}
      />
    </CancelPopup>
  );
}

CancelPendingInvitationsPopup.propTypes = {
  user: PropTypes.object,
  onClose: PropTypes.func,
  succeed: PropTypes.bool,
  rejected: PropTypes.bool,
  clearRequests: PropTypes.func,
  formatMessage: PropTypes.func,
  targetUserId: PropTypes.number,
  cancelGuardianInvite: PropTypes.func,
  cancelCaregiverInvite: PropTypes.func,
  cancelFamilyMemberInvite: PropTypes.func,
};

export default enhance(CancelPendingInvitationsPopup);



// WEBPACK FOOTER //
// ./src/components/CircleOfCare/CancelPendingInvitationsPopup/index.jsx